/*
 * TASK POPUP FOOTER
 *
 * Aligns the task notification preference and form actions across task popups.
 *
 * Recent changes:
 * - Uses the shared popup footer surface while retaining the task email switch.
 */

import { ReactNode } from 'react';
import { THEME_CLASSES } from '../../../constants/themeConstants';
import PopupFooterSurface from '../../popup/PopupFooterSurface';

interface TaskPopupFooterProps {
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  disabled?: boolean;
  label?: string;
  actions: ReactNode;
  showNotification?: boolean;
  testId?: string;
}

export default function TaskPopupFooter({
  checked = true,
  onCheckedChange,
  disabled = false,
  label = 'Notify assignee by email',
  actions,
  showNotification = true,
  testId,
}: TaskPopupFooterProps) {
  const notificationControl = showNotification ? (
        <label className={`flex w-fit cursor-pointer items-center gap-3 text-sm ${THEME_CLASSES.text.primary}`}>
          <input
            type="checkbox"
            checked={checked}
            onChange={(event) => onCheckedChange?.(event.target.checked)}
            disabled={disabled}
            className="peer sr-only"
          />
          <span className="relative h-6 w-11 shrink-0 rounded-full bg-slate-300 transition-colors after:absolute after:left-1 after:top-1 after:h-4 after:w-4 after:rounded-full after:bg-white after:shadow-sm after:transition-transform peer-checked:bg-blue-600 peer-checked:after:translate-x-5 peer-focus-visible:ring-2 peer-focus-visible:ring-blue-500 peer-focus-visible:ring-offset-2 peer-disabled:opacity-60 dark:bg-slate-700" aria-hidden="true" />
          <span>{label}</span>
        </label>
      ) : null;

  return (
    <PopupFooterSurface
      testId={testId}
      leading={notificationControl}
      actions={actions}
      className="-mx-5 -mb-5 mt-6 sm:-mx-6 sm:-mb-6"
    />
  );
}
